// Ngũ hành + Quang / Ám (GLOSSARY §2). Id tiếng Anh theo GLOSSARY.
export const ELEMENT_IDS = ['metal', 'wood', 'water', 'fire', 'earth', 'light', 'dark'] as const;
export type Element = (typeof ELEMENT_IDS)[number];
